import { SnackbarService } from './../services/snackbar-service/snackbar.service';
import { from, Observable, of, timer } from 'rxjs';
import { catchError, map, retry, switchMap, tap } from 'rxjs/operators';

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication/authentication.service';

export const AuthGuard: CanActivateFn = (): Observable<boolean> => {
  const router = inject(Router);
  const authenticationService = inject(AuthenticationService);
  const snackbarService = inject(SnackbarService);

  return of(authenticationService.isLoggedIn()).pipe(
    switchMap(isLoggedIn => {
      if (isLoggedIn) {
        return from(authenticationService.refreshTokenIfNeeded()).pipe(
          retry({
            count: 2,
            delay: () => timer(2000)
          }),
          switchMap(() => from(authenticationService.getToken()))
        );
      }
      snackbarService.openFailureSnackBar('Você precisa estar logado para acessar esta página.');
      return of(false);
    }),
    map(token => {
      if (!token) {
        router.navigate(['/inicio']);
        return false;
      }
      return true;
    }),
    catchError(error => {
      router.navigate(['/inicio']);
      return of(false);
    })
  );
};